import { Component, HostListener, Input, isDevMode, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Observable, Subscription, forkJoin } from 'rxjs';
import { AlertService } from '../global/services/alert.service';
import { GetJsonObjectService } from '../global/services/get-json-object.service';
import { PostJsonObjectService } from '../global/services/post-json-object.service';
import { DeleteJsonObjectService } from '../global/services/delete-json-object.service';
import { PutJsonObjectService } from '../global/services/put-json-object.service';
import { SharedMenuService } from '../global/services/shared-menu.service';
import { HashTable, tools } from '../global/services/tools';
import { first, map } from 'rxjs/operators';
import { columnDefinition } from '../global/prime-ng-array-d4/prime-ng-array-d4.service';
import { PrimeNgArrayD4Service } from '../global/prime-ng-array-d4/prime-ng-array-d4.service';
import { CommunicationService, SharedMultiWindowsService } from '../global/multi-window-container/communication.service';
import { deviceService } from '../global/services-hardware/deviceService';
import { MaterialModule } from '../material-module';
import { PrimeNgArrayD4Component } from '../global/prime-ng-array-d4/prime-ng-array-d4.component';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-drag-ndrog-pool-array-container',
  templateUrl: './drag-ndrog-pool-array-container.component.html',
  styleUrls: ['./drag-ndrog-pool-array-container.component.scss'],
  imports: [
    MaterialModule,
    PrimeNgArrayD4Component,
    CommonModule
  ],
  standalone: true
})
export class DragNDrogPoolArrayContainerComponent implements OnInit {

  @Input() public columnsDefinition: columnDefinition[] = []
  @Input() public apiUrl: string = ""
  @Input() public poolName: string = ""
  public companyIndiceSubscription: Subscription;
  public scrollHeightOffset = -34;
  public loading: boolean = true;
  public itemDrag: any;
  private globalFilterValue: string = "";
  private appTitle: string = ""
  public summaryListItem: summaryItem[] = [];
  public type: string = '';
  public arrayTitle: string = ""
  public isParentAlive: boolean = true

  public arrayList: any[] = [];
  telInputInstance: any;
  jsonSummary: string = "";
  private transformFunctionInput: string = "";
  private transformFunctionOutput: string = "";
  private dataOrigin: "api" | "local" = "api";
  private data: any[] = [];


  constructor(private getJsonService: GetJsonObjectService, private multiWindowsService: SharedMultiWindowsService,
    private deviceService: deviceService,
    private alertService: AlertService, private postJsonObject: PostJsonObjectService,
    private tools: tools, private sharedMenuServices: SharedMenuService, private primeNgArrayD4Service: PrimeNgArrayD4Service
  ) {
    this.companyIndiceSubscription = this.sharedMenuServices.companyIndice$.subscribe(
      value => {
        this.initData();
      }
    );

    this.multiWindowsService.appTitle$.pipe().subscribe((val: string) => {
      this.arrayTitle = val
    })

    this.multiWindowsService.isParentStilAlive$.pipe().subscribe((val: boolean) => {
      this.isParentAlive = val
    })

    this.multiWindowsService.eventDispatcher$.pipe().subscribe(event => {
      if (isDevMode())
        console.log("INIT " + new Date().toTimeString() + "- eventDispatcher event", event)
      if (event.key == "initialisation") {
        this.apiUrl = event.value["getUrl"]
        this.type = event.value["type"]
        this.columnsDefinition = event.value["columnsDefinition"]
        this.dataOrigin = event.value["dataOrigin"]
        this.data = event.value["data"]
        this.transformFunctionInput = event.value["transformFunctionInput"]
        this.transformFunctionOutput = event.value["transformFunctionOutput"]
        this.initData()
      }
    })
  }

  ngOnInit() {

  }

  private initData() {
    this.arrayList = [];
    this.loading = false;
    if (this.dataOrigin == "api") {
      this.getList("", 2000, this.apiUrl)
        .pipe(
          first()).subscribe(
            result => {
              if (result != null) {
                this.loading = false;
                if (this.transformFunctionInput == undefined)
                  this.arrayList = result;
                else {
                  let inputFunction = Function("inputArray", this.transformFunctionInput)
                  this.arrayList = inputFunction(result)
                }
                console.log("DATA LOAD " + new Date().toTimeString() + "- eventDispatcher event", event)
              }
            });
    }
    else if (this.data != undefined) {
      if (this.transformFunctionInput == undefined)
        this.arrayList = this.data;
      else {
        let inputFunction = Function("inputArray", this.transformFunctionInput)
        this.arrayList = inputFunction(this.data)
        if (isDevMode())  console.log("arrayList from parent : ", this.arrayList)
      }
    }
  }

  private getList(filter: string = "", limite: number = 2000, url: string): Observable<any> {
    let option = "l=" + limite;
    if (filter != '')
      option = option + "&f=" + filter;

    return this.getJsonService.getJson(url + "?" + encodeURI(option))
      .pipe(
        map(result => {
          if (result.error == undefined)
            return result;
          else
            return [];
        }),
      );
  }


  public refresh() {
    this.getList(this.globalFilterValue, 2000, this.apiUrl)
      .pipe(
        first()).subscribe(
          result => {
            this.loading = false;
            this.arrayList = result;
          });

  }

  public rowSelection(event: any) {
    if (event != null && event.id != null && event.id != '') {
      console.log("event", event);
    }
    else {
      // this.linesList = null;
    }
  }
}


export interface summaryItem {
  value: any,
  type: string,
  name: string;
  readOnly: boolean;
}
